import React from 'react'
import Pagination from 'antd/es/pagination'
import styles from './PlanOverridesComponents.module.scss'

interface Props {
  page: number
  limit: number
  total: number
  onPageChange: (page: number) => void
  onLimitChange: (limit: number) => void
  pageSizeOptions?: number[]
}

const DEFAULT_PAGE_SIZE_OPTIONS = [10, 20, 50, 100]

export default function PlanOverridesPagination({
  page,
  limit,
  total,
  onPageChange,
  onLimitChange,
  pageSizeOptions = DEFAULT_PAGE_SIZE_OPTIONS,
}: Props) {
  return (
    <div className={styles.container}>
      <Pagination
        current={page}
        pageSize={limit}
        total={total}
        onChange={onPageChange}
        showSizeChanger
        pageSizeOptions={pageSizeOptions.map(String)}
        onShowSizeChange={(_current, size) => onLimitChange(size)}
        showTotal={(t, range) => `${range[0]} to ${range[1]} of ${t}`}
      />
    </div>
  )
}
